import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UiCoreModule} from '@softline/ui-core';

@Component({
    selector: 'lib-product-detail-field',
    imports: [CommonModule, UiCoreModule],
    templateUrl: './product-detail-field.component.html',
    styleUrls: ['./product-detail-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductDetailFieldComponent {

  // tslint:disable-next-line:variable-name
  private _value: string | number | null | undefined = null;

  @Input()
  get value() { return this._value; }
  set value(value: string | number | null | undefined) {
    this._value = value;
  }
  @Input() valueType: 'text' | 'currency' | 'image' = 'text';
  @Input() label: string | null = '';

  @Input() businessCardPrice?: number;

  get valueOrMax(): string | number | null {
    if (typeof this._value === 'string' && !isNaN(+this._value)) {
      return (+this._value > 10000) ? 10000 : +this._value;
    }

    if (typeof this._value === 'number') {
      return (this._value as number > 10000) ? 10000 : this._value;
    }

    return '0';
  }

  get isTranslatable(): boolean | undefined { return this.label?.startsWith('#'); }
}

